export default __webpack_public_path__ + "static/media/ref_data.9f398baf.png";